import { render, staticRenderFns } from "./selectZipAddr.vue?vue&type=template&id=10898906&scoped=true&"
import script from "./selectZipAddr.vue?vue&type=script&lang=js&"
export * from "./selectZipAddr.vue?vue&type=script&lang=js&"
import style0 from "./selectZipAddr.vue?vue&type=style&index=0&id=10898906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10898906",
  null
  
)

export default component.exports